<template>
    <div class="detail">
        <div class="order-status flex">
            <div class="placeInfo-item flex">
                <div class="label">下单时间：</div>
                <div class="value">2023-05-12 12:45:08</div>
            </div>
            <div class="placeInfo-item flex">
                <div class="label">当前订单状态：</div>
                <div class="value">买家未付款</div>
            </div>
            <div class="countdownTip">
                买家还有2天23小时59粉12秒支付订单，否则系统将自动关闭订单
            </div>
            <div class="tip">
                如果商品被恶意拍下，您可以后台取消订单
            </div>
            <!-- <el-button type="primary">关闭交易</el-button> -->
            <el-button type="primary" @click="openDelivery">发货</el-button>
        </div>

        <div class="detail-main">
            <div class="detail-main-item">
                <div class="title">买家信息</div>
                <div class="buyerInfo content">
                    <div class="buyerInfo-item">
                        <div class="label">用户昵称：</div>
                        <div class="value">石头</div>
                    </div>
                    <div class="buyerInfo-item">
                        <div class="label">支付方式：</div>
                        <div class="value">微信支付（交易流水号）</div>
                    </div>
                    <div class="buyerInfo-item">
                        <div class="label">收货地址：</div>
                        <div class="value">陈小姐，18201652086，广东省深圳市福田区华强北街道华强北路1019号华强广场酒店</div>
                    </div>
                </div>
            </div>
            <div class="detail-main-item">
                <div class="title">物流信息</div>
                <el-table class="content" style="width: 100%;">
                    <el-table-column prop="date" label="包裹"></el-table-column>
                    <el-table-column prop="date" label="配送方式"></el-table-column>
                    <el-table-column prop="date" label="物流公司名称"></el-table-column>
                    <el-table-column prop="date" label="物流状态"></el-table-column>
                    <el-table-column prop="date" label="运单号"></el-table-column>
                    <el-table-column prop="date" label="发货时间"></el-table-column>
                    <el-table-column label="操作"></el-table-column>
                </el-table>
            </div>
            <div class="detail-main-item">
                <div class="title">订单信息</div>
                <div class="orderInfo content">
                    <div class="orderInfo-title flex">
                        <div class="item">
                            订单编号：<span>45432156721216521</span>
                        </div>
                        <div class="item">
                            下单时间：<span>2023-04-30 20：59：35</span>
                        </div>
                        <div class="item">
                            付款时间：<span>2023-04-30 21：04：02</span>
                        </div>
                    </div>

                    <el-table :data="info.goodsInfo" border
                        :span-method="resetGoodsTable"
                        style="width: 100%; margin: 20px 0;">
                        <el-table-column label="包裹" width="80">
                            <template>
                                1
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="商品"></el-table-column>
                        <el-table-column prop="price" label="单价（元）*数量" align="center"></el-table-column>
                        <el-table-column label="商品总价（元）" align="center" width="260">
                            <template>
                                160
                            </template>
                        </el-table-column>
                        <el-table-column label="优惠（元）" align="center" width="260">
                            <template>
                                30
                            </template>
                        </el-table-column>
                    </el-table>

                    <div class="priceInfo">
                        <div class="item flex">
                            <div class="label">订单商品金额：</div>
                            <div class="value">320.00元</div>
                        </div>
                        <div class="item flex">
                            <div class="label">订单商品配送费：</div>
                            <div class="value">+20.00元</div>
                        </div>
                        <div class="item flex">
                            <div class="label">订单优惠金额：</div>
                            <div class="value red">-30.00元</div>
                        </div>
                        <div class="item flex">
                            <div class="label">订单实收：</div>
                            <div class="value red">310.00元</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog
            title="发货"
            custom-class="dialogRadius"
            :visible.sync="isDeliveryShow"
            :before-close="closeDelivery">
            <el-form :model="deliveryForm" label-width="auto">
                <el-form-item label="配送方式：">
                    <el-select v-model="deliveryForm.mode" placeholder="请选择" style="width: 100%">
                        <el-option label="快递物流" value="1"></el-option>
                        <el-option label="无需物流" value="0"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="物流公司名称：">
                    <el-input v-model="deliveryForm.name" placeholder="请输入物流公司名称，例：顺丰"></el-input>
                </el-form-item>
                <el-form-item label="运单号：">
                    <el-input v-model="deliveryForm.number" placeholder="请输入运单号"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDelivery">取 消</el-button>
                <el-button type="primary" @click="submitDelivery">确认发货</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    data() {
        return {
            info: {
                order_time: '',
                status: '',
                buyerInfo:{
                    name: '',
                    account: '',
                    payMode: '',
                    order_no: '',
                    adderss: '',
                },
                deliveryInfo: {
                    delivery_mode: '',
                    delivery_name: '',
                    delivery_status: '',
                    delivery_number: '',
                    delivery_time: '',
                },
                goodsInfo:[
                    {
                        id: 1,
                        name: '商品名称商品名称商品名称商品名称 规格 ',
                        price: '8.00',
                        number: 3,
                    },
                    {
                        id: 1,
                        name: '商品名称商品名称商品名称商品名称 规格 ',
                        price: '8.00',
                        number: 3,
                    },
                    {
                        id: 1,
                        name: '商品名称商品名称商品名称商品名称 规格 ',
                        price: '8.00',
                        number: 3,
                    }
                ],
                orderInfo:{
                    order_no: '',
                    order_time: '',
                    pay_time: '',
                    amount: '',
                    delivery_fee: '',
                    discount: '',
                    paid_in: ''
                }
            },
            isDeliveryShow: false,
            deliveryForm: {
                mode: '',
                name: '',
                number: ''
            }
        }
    },
    computed:{
        ...mapState({
            tagList: state => state.tagList,
            tagActiveIndex: state => state.tagActiveIndex
        }),
    },
    created() {
        console.log(this.$route.params.id);
    },
    methods: {
        goBack(){
            this.$store.commit('delTag', this.tagActiveIndex);
            let index = this.tagActiveIndex - 1;
            this.$store.commit('setTagActiveIndex', index);
            this.$router.back();
        },
        openDelivery(){
            this.isDeliveryShow = true;
        },
        closeDelivery(){
            this.isDeliveryShow = false;
        },
        submitDelivery(){

        },
        // 重置订单信息表格
        resetGoodsTable({ row, column, rowIndex, columnIndex }){
            if(columnIndex === 0 || columnIndex === 3 || columnIndex === 4){
                if(rowIndex === 0){
                    return {
                        rowspan: this.info.goodsInfo.length,
                        colspan: 1
                    }
                }else{
                    return {
                        rowspan: 0,
                        colspan: 0
                    }
                }
            }else{
                return {
                    rowspan: 1,
                    colspan: 1
                }
            }
        }
    },
}
</script>
<style lang="less" scoped>
    /deep/.el-input__inner{
        background-color: #FAFAFA;
        border-color: transparent;
        outline: none;

        &:focus,
        &:hover{
            background-color: #fff;
            border-color: #0C78D7;
        }
    }
    /deep/.el-table th.el-table__cell{
        background-color: #F4F5F7;
    }
    /deep/.dialogRadius{
        width: 460px;
        overflow: hidden;
        .el-dialog__header{
            background-color: #FBFCFC;
            border-bottom: 1px solid #EBEEF2;
            .el-dialog__title{
                color: #333;
            }
        }
    }
    .detail{
        padding-bottom: 20px;
        .order-status{
            flex-direction: column;
            align-items: flex-start;
            justify-content: space-around;
            box-sizing: border-box;
            padding: 20px 40px;
            height: 220px;
            border: 10px solid #F0F2F5;
            border-left: none;
            border-right: none;
            color: #666;
            font-size: 14px;
            .placeInfo-item{
                align-items: center;
                .label{
                    text-align: right;
                }
                .value{
                    color: #333;
                }
            }
            .tip{
                color: #09baef;
            }
        }
        .detail-main{
            padding: 0 20px;

            .detail-main-item{
                .title{
                    margin-bottom: 20px;
                    height: 48px;
                    line-height: 48px;
                    border-bottom: 1px solid #e6e6e6;
                    font-size: 14px;
                    color: #333;
                }
                .content{
                    padding: 0 20px;
                }
                .buyerInfo-item{
                    display: flex;
                    align-items: center;
                    margin-top: 14px;
                    font-size: 14px;

                    .label{
                        color: #666;
                    }
                    .value{
                        color: #333;
                    }
                }
                .orderInfo-title{
                    align-items: center;
                    .item{
                        margin-right: 20px;
                        color: #666;
                        font-size: 14px;
                        span{
                            color: #333;
                        }
                    }
                }

                .priceInfo{
                    font-size: 14px;
                    .item{
                        justify-content: flex-end;
                        margin-top: 16px;
                        .label{
                            color: #666;
                            width: 120px;
                            text-align: right;
                        }
                        .value{
                            width: 150px;
                            color: #333;

                            &.red{
                                color: #ff5c4d;
                            }
                        }
                    }
                }
            }
        }
    }
</style>